import React from 'react';
import { Alert, Box, Dialog, Grid, Stack } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import { CustomButton, CustomDialogAction, CustomDialogContent, CustomDialogTitle, CustomInputLabel, CustomTextField, InputProps, StyledCard } from '../../../../../custom/components';
import { CloseIconBtn } from 'custom/constants';
import CombineAirlineModal from './CombineAirlineModal';
import AirlineLogoUpload from './AirlineLogoUpload';

const AirlineModal = (props) => {
  const addEditAirline = <form onSubmit={props.addAirline} className={styles.w100}>
    <CustomDialogContent>
      <StyledCard>
        <Grid container spacing={2} rowSpacing={0}>
          <Grid item xs={12} md={12}>
            <CustomInputLabel htmlFor='name' required>Name</CustomInputLabel>
            <CustomTextField
              {...InputProps}
              id='name'
              fullWidth
              autoFocus
              placeholder='Name'
              type='text'
              onChange={props.onChange}
              name='name'
              value={props.airlineFields.name}
              error={props.airlineErrors.name}
              helperText={props.airlineErrors.name}
            />
          </Grid>

          <Grid item xs={12} lg={6}>
            <CustomInputLabel htmlFor='code' required>Code</CustomInputLabel>
            <CustomTextField
              {...InputProps}
              id='code'
              fullWidth
              placeholder='Code'
              type='text'
              onChange={props.onChange}
              name='code'
              value={props.airlineFields.code}
              error={props.airlineErrors.code}
              helperText={props.airlineErrors.code}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <CustomInputLabel htmlFor='awb_pre' required>Airwaybill Prefix</CustomInputLabel>
            <CustomTextField
              {...InputProps}
              id='awb_pre'
              fullWidth
              placeholder='Airwaybill Prefix'
              type='text'
              onChange={props.onChange}
              name='awb_pre'
              value={props.airlineFields.awb_pre}
              error={props.airlineErrors.awb_pre}
              helperText={props.airlineErrors.awb_pre}
            />
          </Grid>
        </Grid>
      </StyledCard>
      <Box component='div'>
        <AirlineLogoUpload
          key={`${props.openAddAirline}-${props.airlineFields.id || 'new'}`}
          preview={props.logoPreview}
          onChange={props.onLogoChange}
          onPendingChange={props.onLogoPendingChange}
        />
        {props.airlineErrors.logo && <Alert severity='error'>{props.airlineErrors.logo}</Alert>}
      </Box>
    </CustomDialogContent>
    <CustomDialogAction className={styles.fSpaceBtw}>
      <CustomButton variant='contained' onClick={props.handleClose}>Close</CustomButton>
      <CustomButton variant='contained' type='submit' disabled={props.logoPending}>{props.type == 'edit' ? 'Update' : 'Submit'}</CustomButton>
    </CustomDialogAction>
  </form>;

  const combineAirline = 
    <Box component='form' onSubmit={props.combineAirline} className={styles.w100}>
      <CustomDialogContent>     
        <CombineAirlineModal
          openCombineAirline={props.openCombineAirline}
          handleClose={props.handleClose}
          handleOpen={props.handleOpen}
          airlineList={props.airlineList}
          combinationList={props.combinationList}
          combineAirlineFields={props.combineAirlineFields}
          onChange={props.onChange}
          combineAirlineErrors={props.combineAirlineErrors}
          combineAirline={props.combineAirline}
          onChangeCombineAirline={props.onChangeCombineAirline}
          type={props.type}
          addAirlineCombination={props.addAirlineCombination}
          updateAirlineCombination={props.updateAirlineCombination}
          deleteAirlineCombination={props.deleteAirlineCombination}
          handleCombineEdit={props.handleCombineEdit}
        />
      </CustomDialogContent>
      <CustomDialogAction>
        <Stack direction='row' spacing={2} justifyContent='space-between' width='100%'>
          <CustomButton variant='contained' onClick={() => props.handleCombineEdit({})}>Close</CustomButton>
          <CustomButton variant='contained' onClick={props.combineAirlineFields.id ? props.updateAirlineCombination : props.addAirlineCombination}>{props.combineAirlineFields.id ? 'Update' : 'Submit'}</CustomButton>
        </Stack>
      </CustomDialogAction>
    </Box>;

  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.openAddAirline} onClose={props.handleClose} fullWidth maxWidth='sm'>
        <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>{props.type == 'edit' ? 'Edit' : 'Add'} {props.tab === 'combineAirlines' ? 'Airline Alliance' : 'Airline'}
          <CloseIconBtn onClick={props.handleClose} />
        </CustomDialogTitle>
        {/* <Stack direction='row' spacing={1} justifyContent='flex-end' sx={{
          padding: '10px 24px',
          pb: 0,
          mb: '-12px' 
        }}>
          <Switch
            size='small'
            onChange={props.onToggleType}
            className={styles.switch}
            classes={{
              switchBase: styles.switchBase,
              checked: styles.switchChecked,
              track: styles.switchTrack,
              thumb: styles.switchThumb,
            }}
          />
          <Typography variant='body2' fontWeight={600}>Combine airlines</Typography>
        </Stack> */}

        {((props.type === 'add' || props.type === 'edit')&& props.tab === 'combineAirlines') && combineAirline}
        {((props.type === 'add' || props.type === 'edit') && props.tab === 'airlines') && addEditAirline}
        
      </Dialog>
    </div>
  );
};
export default AirlineModal;